// extracted by mini-css-extract-plugin
export default {"CheckBox":"CheckBox_CheckBox__loXAa","ReadOnly":"CheckBox_ReadOnly__gvyPU"};